import { useState, useContext } from "react";

import api, { API_URL, AuthContext, BACKEND_URL, showAlert } from "../util/api";

export default function Profile() {

    const { User  , kycchange } = useContext(AuthContext);

    const [editing, setEditing] = useState(true);

    const handleEdit = () => setEditing(!editing);
    const handleUserChange = (e) => {
        //setUser({ ...user, [e.target.name]: e.target.value });

    };

    const [form, setForm] = useState({
        name: User.name,
        email: User.email,
        phone: User.phone,
        gender: User.gender,
        bio: User.bio,
        dob_day: User.dob_day,
        dob_month: User.dob_month
    });

    const [picture, setPicture] = useState(null);
    const [preview, setPreview] = useState(BACKEND_URL + User.picture);
    const [uploadProgress, setUploadProgress] = useState(0);
    // Desired image size
    /* 1920 × 1080 */
    const MAX_WIDTH = 1920;
    const MAX_HEIGHT = 1080;
    const QUALITY = 0.8; // compression quality
    const [loading, setLoading] = useState(false);



    const handleChange = (e) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    // ✅ RESIZE IMAGE FUNCTION
    const resizeImage = (file) => {
        return new Promise((resolve) => {
            const img = new Image();
            const reader = new FileReader();

            reader.onload = (e) => {
                img.src = e.target.result;
            };

            img.onload = () => {
                let width = img.width;
                let height = img.height;

                // Maintain aspect ratio
                if (width > MAX_WIDTH || height > MAX_HEIGHT) {
                    const ratio = Math.min(MAX_WIDTH / width, MAX_HEIGHT / height);
                    width = width * ratio;
                    height = height * ratio;
                }

                const canvas = document.createElement("canvas");
                canvas.width = width;
                canvas.height = height;

                const ctx = canvas.getContext("2d");
                ctx.drawImage(img, 0, 0, width, height);

                // Convert to blob
                canvas.toBlob(
                    (blob) => {
                        const newFile = new File([blob], file.name, {
                            type: "image/jpeg",
                        });
                        resolve(newFile);
                    },
                    "image/jpeg",
                    QUALITY
                );
            };

            reader.readAsDataURL(file);
        });
    };

    // ✅ HANDLE IMAGE (AUTO RESIZE)
    const handlePictureChange = async (e) => {
        const file = e.target.files[0];
        if (!file) return;

        if (!file.type.startsWith("image/")) {
            showAlert("error", "Invalid File", "Only image files are allowed!", 4000);
            e.target.value = "";
            return;
        }

        try {
            // Resize image
            const resizedImage = await resizeImage(file);

            setPicture(resizedImage);
            setPreview(URL.createObjectURL(resizedImage));

        } catch (error) {
            showAlert("error", "Image Error", "Failed to process image, please change the image", 4000);
        }
    };

    const submitForm = async (e) => {
        e.preventDefault();

        if (form.password !== form.confirm_password) {
            showAlert("error", "Password Error", "Passwords do not match!", 4000);
            return;
        }



        try {
            const formData = new FormData();
            setLoading(true);

            Object.keys(form).forEach(key => formData.append(key, form[key]));

            if (picture) {
                formData.append("picture", picture);
            }

            let response = await api.post(`${API_URL}/update_profile`, formData, {
                headers: { "Content-Type": "multipart/form-data" },
                onUploadProgress: (progressEvent) => {
                    const percent = Math.round((progressEvent.loaded * 100) / progressEvent.total);
                    setUploadProgress(percent);
                }
            });

            if (response.data.success === true) {
                showAlert(
                    "success",
                    "Successful!",
                    response.data.message,
                    5000
                );

                kycchange(response.data.data);

            } else {
                showAlert("error", "Profile Update Failed", response.data.message, 5000);
            }

            setLoading(false);

        } catch (e) {
            showAlert("error", "Profile Update Failed", `Your profile update failed. Please try again later. ${e.message}`, 5000);
            setUploadProgress(0);
            setLoading(false);
        }
    };



    return (

        <>
            <div className="">
                <div className="card-header">
                   {/*  <h3>User Profile</h3> */}

                   {/*  <button onClick={handleEdit}>
                        {editing ? "Save" : "Edit"}
                    </button> */}
                </div>

                <div align="left" style={{ maxWidth: "100%" }} className="profile  register-box" >




                    <form onSubmit={submitForm}  >

                          {preview && (
                                <div align="left"   >
                                    <img
                                        src={preview}
                                        alt="Preview"
                                        style={{
                                            width: 200,
                                            height: 400,
                                            objectFit: "contain",
                                           /*  borderRadius: "20%"  */
                                        }}
                                    />
                                </div>
                            )}

                        {/* IMAGE UPLOAD */}
                        <div align="left" style={{ margin: "12px 0" }}>
                            
                            <label  >Change picture</label>

                            <input
                                style={{ color: "black" }}
                                type="file"
                                accept="image/*"
                                onChange={handlePictureChange}
                            />

                           
                        </div>

                        <label align="left">Full Name</label>

                        <input
                            style={{ color: "black" }}
                            type="text"
                            name="name"
                            placeholder="Full Name"
                            value={form.name}
                            disabled={!editing}
                            onChange={handleChange}
                            required
                        />

                        <label align="left">Email</label>


                        <input
                            style={{ color: "black" }}
                            type="email"
                            name="email"
                            placeholder="Email Address"
                            value={form.email}
                            disabled={!editing}
                            onChange={handleChange}
                            required
                        />

                        <label align="left">Phone</label>
                         

                        <input
                            style={{ color: "black" }}
                            type="text"
                            name="phone"
                            placeholder="Phone Number"
                            value={form.phone}
                            disabled={!editing}
                            onChange={handleChange}
                            required
                        />


                        


                        <label align="left">Gender</label>


                        <select
                            name="gender"
                            value={form.gender}
                            onChange={handleChange}
                            required
                            disabled={!editing}
                        >
                            <option value="">Select Gender</option>
                            <option value="male">Male</option>
                            <option value="female">Female</option>
                        </select>


                           {/* DOB */}
                        <label align="left">Date of Birth</label>
                        <div style={{ display: "flex", gap: "10px" }}>
                            <select name="dob_day" value={form.dob_day} onChange={handleChange} required>
                                <option value="">Day</option>
                                {[...Array(31)].map((_, i) => (
                                    <option key={i + 1} value={i + 1}>{i + 1}</option>
                                ))}
                            </select>

                            <select name="dob_month" value={form.dob_month} onChange={handleChange} required>
                                <option value="">Month</option>
                                {[
                                    "January", "February", "March", "April", "May", "June",
                                    "July", "August", "September", "October", "November", "December"
                                ].map((month, i) => (
                                    <option key={i + 1} value={i + 1}>{month}</option>
                                ))}
                            </select>
                        </div>

                        <label align="left">About You </label>
                          


                        <textarea
                            name="bio"
                            value={form.bio}
                            disabled={!editing}
                            onChange={handleChange}
                        />






                        {/* UPLOAD PROGRESS */}
                        {uploadProgress > 0 && (
                            <div style={{ marginBottom: 10 }}>
                                <div style={{
                                    height: 8,
                                    width: "100%",
                                    backgroundColor: "#ddd",
                                    borderRadius: 4
                                }}>
                                    <div
                                        style={{
                                            width: `${uploadProgress}%`,
                                            height: "100%",
                                            backgroundColor: "#4caf50",
                                            borderRadius: 4,
                                            transition: "width 0.3s"
                                        }}
                                    />
                                </div>
                                <span style={{ fontSize: 12 }}>{uploadProgress}%</span>
                            </div>
                        )}

                        <button disabled={loading} type="submit">
                            {loading ? "Loading..." : "Update Profile"}
                        </button>

                    </form>







                </div>
            </div>
        </>
    )

}